import { ReactElement, useRef, useState } from 'react';
import {
  Modal, ModalHeader, ModalBody, ModalFooter,
} from 'react-bootstrap';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import {
  Button, FormGroup, Col, InputUnform,
} from '../../components';
import { alerts, api } from '../../utils';
import validate from './validar-form-change-pass';

interface Props {
  show: boolean;
  closeModal: () => void;
}

interface ChangPassword {
  senhaAtual: string;
  senha: string;
  newPassword: string;
}

function ModalChangePassword({ show, closeModal }: Props): ReactElement {
  const [loadButton, setLoadButton] = useState<boolean>(false);

  const formRef = useRef<FormHandles>(null);

  const handlerChangePassword = async (data: ChangPassword) => {
    try {
      if (data.senha !== data.newPassword) {
        formRef.current?.setErrors({ newPassword: 'Senhas não correspondem' });
        return;
      }

      formRef.current?.setErrors({});
      await validate.formulario(data);

      setLoadButton(true);

      await api.changePasswordUserAuthenticated(data);

      closeModal();

      alerts.exibirToastSuccess('Senha alterada com sucesso');
    } catch (error) {
      alerts.exibirErrorCatch(error, formRef);
    } finally {
      setLoadButton(false);
    }
  };

  return (
    <Modal show={show}>
      <ModalHeader>
        Alterar senha
      </ModalHeader>
      <Form ref={formRef} onSubmit={handlerChangePassword}>
        <ModalBody>
          <FormGroup className="mx-sm-3 mb-2">
            <Col col={12}>
              <InputUnform
                key="forgot-password-1"
                type="password"
                name="senhaAtual"
                className="form-control form-control-user"
                placeholder="Senha atual"
              />
            </Col>
          </FormGroup>
          <FormGroup className="mx-sm-3 mb-2">
            <Col col={12}>
              <InputUnform
                key="forgot-password-2"
                type="password"
                name="senha"
                className="form-control form-control-user"
                placeholder="Nova senha"
              />
            </Col>
          </FormGroup>
          <FormGroup className="mx-sm-3 mb-2">
            <Col col={12}>
              <InputUnform
                key="forgot-password-2"
                type="password"
                name="newPassword"
                className="form-control form-control-user"
                placeholder="Repetir nova senha"
              />
            </Col>
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button
            type="button"
            className="btn btn-primary d-flex align-items-center"
            onClick={closeModal}
          >
            Voltar
          </Button>
          <Button
            type="submit"
            className="btn btn-success mb-2"
            load={loadButton}
          >
            Salvar
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
}

export default ModalChangePassword;
